// extracted by mini-css-extract-plugin
export default {"noCycle":"Dashboard_noCycle__NIMR3","widgets":"Dashboard_widgets__aUpGT"};